import React, { useState } from "react";
import Layout from "@/components/layout/Layout";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      setDone(true);
      if (data.already_subscribed) toast.success("You're already subscribed — thanks!");
      else toast.success("Subscribed! You'll receive Etherscan updates.");
    } catch (ex) {
      const d = ex.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Failed to subscribe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <div className="flex items-center gap-3 mb-4">
        <Mail className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold" data-testid="newsletter-title">Newsletter</h1>
      </div>
      <div className="ks-card p-6 max-w-lg">
        {done ? (
          <div className="flex flex-col items-center text-center gap-2 py-4" data-testid="newsletter-done">
            <Check size={40} className="text-[var(--ks-success)]" />
            <div className="font-semibold text-lg">You&apos;re on the list</div>
            <p className="text-sm text-[var(--ks-text-soft)]">We&apos;ll drop Etherscan updates in your inbox occasionally. No spam.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3" data-testid="newsletter-form">
            <p className="text-sm text-[var(--ks-text-soft)]">
              Get occasional updates about Etherscan, new features and released tools.
            </p>
            <Input
              type="email"
              required
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="newsletter-email"
            />
            <Button type="submit" disabled={busy} className="w-full bg-[var(--ks-primary)] hover:bg-[var(--ks-link-hover)]" data-testid="newsletter-submit">
              {busy ? "Subscribing…" : "Subscribe"}
            </Button>
          </form>
        )}
      </div>
    </Layout>
  );
}
